import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { Table, Thead, Tr, Th, Td } from "commons";

const ALL_TRANS = "All transactions";
const CELL_HEIGHT = "36px";
const NA = "N/A";
const SELECT_ALL = "Select all";

export class FilterSubPanel extends Component {
    filterSelect = event => {
        const mappings = this.props.options;
        Object.keys(mappings)
            .filter(high => high !== NA)
            .forEach(high => {
                if (event.target.id in mappings[high]) {
                    mappings[high][event.target.id].selected =
                        !mappings[high][event.target.id].selected;
                }

                if (event.target.id === ALL_TRANS) {
                    Object.keys(mappings[high]).forEach(
                        transLow =>
                            (mappings[high][transLow].selected =
                                mappings[ALL_TRANS][ALL_TRANS].selected)
                    );
                } else if (high !== ALL_TRANS) {
                    mappings[high][SELECT_ALL].selected =
                        Object.keys(mappings[high]).find(
                            low => low !== SELECT_ALL && mappings[high][low].selected === false
                        ) === undefined;
                }

                if (event.target.id === `${SELECT_ALL}-${high}`) {
                    mappings[high][SELECT_ALL].selected = !mappings[high][SELECT_ALL].selected;
                    Object.keys(mappings[high])
                        .filter(low => low !== SELECT_ALL)
                        .forEach(
                            low =>
                                (mappings[high][low].selected = mappings[high][SELECT_ALL].selected)
                        );
                }
            });

        mappings[ALL_TRANS][ALL_TRANS].selected = this.isAllSelected(mappings);
        this.props.parentFilterSelect(mappings);
    };

    isAllSelected(mappings) {
        for (const allHigh in mappings) {
            for (const allLow in mappings[allHigh]) {
                if (
                    allHigh !== ALL_TRANS &&
                    allHigh !== NA &&
                    mappings[allHigh][allLow].selected === false
                ) {
                    return false;
                }
            }
        }
        return true;
    }

    render() {
        const grouping = [];
        this.props.lows.forEach(lowLevel => {
            const id = lowLevel === SELECT_ALL ? `${lowLevel}-${this.props.title}` : lowLevel;

            while (lowLevel === SELECT_ALL && grouping.length !== this.props.rowNumTarget - 1) {
                grouping.push(
                    <Tr key={grouping.length}>
                        <Td height={CELL_HEIGHT}>&nbsp;</Td>
                    </Tr>
                );
            }
            grouping.push(
                <Tr key={grouping.length}>
                    <Td height={CELL_HEIGHT}>
                        <label htmlFor={id}>{lowLevel}</label>
                        <AlignedInput
                            onChange={this.filterSelect}
                            type="checkbox"
                            checked={this.props.options[this.props.title][lowLevel].selected}
                            id={id}
                        />
                    </Td>
                </Tr>
            );
        });

        return (
            <TableContainer first={this.props.firstPanel}>
                <Table>
                    <Thead>
                        <Tr>
                            <Th align="left">{this.props.title}</Th>
                        </Tr>
                    </Thead>
                    <tbody>{grouping}</tbody>
                </Table>
            </TableContainer>
        );
    }
}

export const AlignedInput = styled.input`
    float: right;
`;

export const TableContainer = styled.div`
    ${props => props.first && "clear: left;"}
    margin-left: 15px;
    width: 200px;
    float: left;
`;

FilterSubPanel.propTypes = {
    title: PropTypes.string,
    parentFilterSelect: PropTypes.func,
    lows: PropTypes.array,
    options: PropTypes.object,
    rowNumTarget: PropTypes.number,
    firstPanel: PropTypes.bool
};
